import { isEmpty, map, size } from 'underscore';
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { List } from '@fluentui/react-list-preview';

import { AdTypePluralStrings, AdTypeMaxCount } from '../../constants/ad-type';
import { AdListItem } from './ad-list-item';

export const AdList = ({
  i18n,
  adType,
  ads,
  enableCopy,
  onCopyAd,
  onEditAd,
  onDeleteAd,
}) => {
  const listHeader = useMemo(() => i18n.getString(_TL_('{{adType}} ({{count}}/{{maxCount}})'), {
    adType: i18n.getString(AdTypePluralStrings[adType]),
    count: size(ads),
    maxCount: AdTypeMaxCount[adType],
  }), [adType, ads, i18n]);

  return !isEmpty(ads) && (
    <div className="ad-list">
      <div className="ad-list-header">
        {listHeader}
      </div>
      <List
        className="ad-list-items"
        navigationMode="composite"
      >
        {map(ads, ad => (
          <AdListItem
            key={ad.Id}
            i18n={i18n}
            ad={ad}
            enableCopy={enableCopy}
            onCopyAd={() => onCopyAd(ad)}
            onEditAd={() => onEditAd(ad)}
            onDeleteAd={() => onDeleteAd(ad)}
          />
        ))}
      </List>
    </div>
  );
};

AdList.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  adType: PropTypes.string.isRequired,
  enableCopy: PropTypes.bool,
  ads: PropTypes.arrayOf(PropTypes.shape({})),
  onCopyAd: PropTypes.func.isRequired,
  onEditAd: PropTypes.func.isRequired,
  onDeleteAd: PropTypes.func.isRequired,
};

AdList.defaultProps = {
  ads: [],
  enableCopy: false,
};
